<div class="container">
  <div class="not-found-container">
    <img src="./assets/shell/not-found.svg" width="250" height="250" alt="" /> <br />
    <span class="not-found-title">{{ 'general.error_404_title' | translate }}</span
    ><br />
    <span class="not-found-text">{{ 'general.error_404_page_not_found' | translate }}</span>
    <br />
    <div class="not-found-text">
      {{ 'general.error_404_page_go_to' | translate }}
      <a routerLink="/" class="not-found-link">{{
        'general.error_404_page_home_page' | translate
      }}</a
      ><span class="not-found-text">.</span>
    </div>
  </div>
</div>
